<template>
	<app-page>
		<app-heading :title="isNew ? 'New Redirection' : redirection.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'website-redirections' }">Cancel</app-button>
				</app-section-actions>
				<input-select
					label="Type"
					:items="types"
					v-model="redirection.type"
					required
				/>
				<input-text
					label="From"
					v-model="redirection.from"
					required
					:disabled="!redirection.type"
					:errors="errors.from"
				/>
				<input-text
					label="To"
					v-model="redirection.to"
					required
					:errors="errors.to"
				/>
				<p class="text-muted small mt-2 mb-0">
					Use <code>*</code> in From to capture path segments;
					use <code>$1</code>, <code>$2</code>, etc. in To (first * → $1, second → $2, …).
					(Note: Only Contains type works with wildcard, other types are not supported.)
				</p>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				const redirection = await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(this.websiteId)
					.to('redirections')
					.to(this.id)
					.get()

				let regexp = redirection.from
				let type = 'contains'
				this.redirection.to = redirection.to

				if (!regexp.includes('*')) {
					if (regexp.substr(0, 1) === '^') {
						regexp = regexp.substr(1)
						type = 'starts'
					}
					if (regexp.substr(-1, 1) === '$') {
						regexp = regexp.substr(0, regexp.length - 1)
						type = type === 'starts' ? 'equals' : 'ends'
					}
				}

				this.redirection.type = type
				this.redirection.from = regexp
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			redirection: {
				type: null,
				from: '',
				to: '',
			},

			types: [{
				text: 'Equals',
				value: 'equals',
			}, {
				text: 'Contains',
				value: 'contains',
			}, {
				text: 'Starts with',
				value: 'starts',
			}, {
				text: 'Ends with',
				value: 'ends',
			}],

			errors: {},
		}
	},
	computed: {
		websiteId() {
			return this.$route.params.website
		},
		id() {
			return this.$route.params.redirection
		},
		isNew() {
			return this.id === 'new'
		},
		regexp() {
			if (!this.redirection.type) { return null }
			// Wildcard patterns (* → $1, $2, …) are stored as-is
			if (this.redirection.from.includes('*')) {
				return this.redirection.from
			}
			return `${this.redirection.type === 'starts' || this.redirection.type === 'equals' ? '^' : ''}`
				+ `${this.redirection.from}`
				+ `${this.redirection.type === 'ends' || this.redirection.type === 'equals' ? '$' : ''}`
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('redirections')
						.create({
							from: this.regexp,
							to: this.redirection.to,
						})
				} else {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('redirections')
						.to(this.id)
						.update({
							from: this.regexp,
							to: this.redirection.to,
						})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Redirection successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'website-redirections' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
